import React from 'react';
import {  Show,BooleanField,
BooleanInput,ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,TabbedForm,FormTab,Create
 }
from 'admin-on-rest/lib/mui';

export const TerminalList = (props) => (
    <List title=" מסופים" {...props}>
        <Datagrid>
            <TextField label="#" source="id" />
              <TextField label="טרמינל" source="terminal" />
              <BooleanField label="פעיל" source="active" />
   <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

const TerminalTitle = ({ record }) => {
    return <span>Terminal {record ? `"${record.bank}"` : ''}</span>;
};


export const TerminalShow = (props) => (

<Show title={<TerminalTitle />} {...props}>
 <SimpleShowLayout>
        <TextField label="#" source="id" />
        <TextField label="טרמינל" source="terminal" />
        <BooleanField label="פעיל" source="active" />

         </SimpleShowLayout>
    </Show>
);


export const TerminalEdit = (props) => (
    <Edit {...props}>

        <SimpleForm>
 <DisabledInput source="id" />
<TextInput  source="terminal" />
<BooleanInput label="פעיל" source="active" />
        </SimpleForm>
  </Edit>
);

export const TerminalCreate = (props) => (
    <Create title="הוספת סוג מסוף חדש" {...props}>
      <SimpleForm >

              <DisabledInput label="Id" source="id" />
                <TextInput source="terminal" label="טרמינל"/>

<BooleanInput label="פעיל" source="active" />




      </SimpleForm>
    </Create>
);



// WEBPACK FOOTER //
// ./src/components/Terminal/terminal.js